import { render } from "./flats-crm-btns.vue?vue&type=template&id=3ed31887"
import script from "./flats-crm-btns.vue?vue&type=script&lang=js"
export * from "./flats-crm-btns.vue?vue&type=script&lang=js"

import "./flats-crm-btns.vue?vue&type=style&index=0&id=3ed31887&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__